import React, { Component } from "react";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
// import get from "lodash/get";
import PostIcons from "../components/post-icons";
import SEO from "../components/seo";
import Img from "gatsby-image";
import Layout from "../layouts";

import { rhythm } from "../utils/typography";

class PostTemplate extends Component {
  render() {
    const post = this.props.data.wordpressPost;
    // const resolutions = get(
    //   post,
    //   "featured_media.localFile.childImageSharp.resolutions"
    // );
    // const alt_text = get(post, "featured_media.alt_text");
    // const mediumUp = "@media screen and (min-width: 768px)";
    const wrapCss = {
      "@media screen and (max-width: 767px)": {
        padding: `0 0.75rem`
      }
    };
    return (
      <Layout>
        <SEO title={post.title} description={post.excerpt} />{" "}
        <style>
          {" "}
          {`
          .sketchfab-embed-wrapper {
            position: relative;
            padding-bottom: 75%; /* 4:3 */
            padding-top: 25px;
            height: 0;
          }
          .sketchfab-embed-wrapper iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        `}{" "}
        </style>{" "}
        <h1
          className="post-heading"
          dangerouslySetInnerHTML={{
            __html: post.title
          }}
          css={{
            ...wrapCss,
            "@media only screen and (max-width: 768px)": {
              fontSize: "1.7rem"
            }
          }}
        />{" "}
        {/* {resolutions && <Img resolutions={resolutions} alt={alt_text} />} */}{" "}
        <PostIcons
          node={post}
          css={{
            marginBottom: rhythm(1 / 2),
            ...wrapCss
          }}
        />{" "}
        <div
          dangerouslySetInnerHTML={{
            __html: post.content
          }}
          css={wrapCss}
        />{" "}
        {post.acf &&
          post.acf.page_builder_post &&
          post.acf.page_builder_post.map((layout, i) => {
            if (layout.__typename === `WordPressAcf_image_gallery`) {
              return (
                <div key={`${i} image-gallery`}>
                  <h2> ACF Image Gallery </h2>{" "}
                  {layout.pictures.map(({ picture }) => {
                    const img = picture.localFile.childImageSharp.fluid;
                    return (
                      <Img
                        css={{
                          marginBottom: rhythm(1)
                        }}
                        key={img.src}
                        fluid={img}
                      />
                    );
                  })}{" "}
                </div>
              );
            }
            if (layout.__typename === `WordPressAcf_post_photo`) {
              const img = layout.photo.localFile.childImageSharp.fluid;
              return (
                <div key={`${i}-photo`}>
                  <h2> ACF Post Photo </h2>{" "}
                  <Img
                    css={{
                      marginBottom: rhythm(1)
                    }}
                    src={img.src}
                    fluid={img}
                  />{" "}
                </div>
              );
            }
            return null;
          })}{" "}
      </Layout>
    );
  }
}

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array
};

export default PostTemplate;

// export const pageQuery = graphql`
//   query($id: String!) {
//     wordpressPost(id: { eq: $id }) {
//       title
//       content
//       ...PostIcons
//       acf {
//         page_builder_post {
//           __typename
//           ... on WordPressAcf_post_photo {
//             photo {
//               localFile {
//                 childImageSharp {
//                   fluid(maxWidth: 680) {
//                     ...GatsbyImageSharpFluid
//                   }
//                 }
//               }
//             }
//           }
//           ... on WordPressAcf_image_gallery {
//             pictures {
//               picture {
//                 localFile {
//                   childImageSharp {
//                     fluid(maxWidth: 680) {
//                       ...GatsbyImageSharpFluid
//                     }
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//     site {
//       siteMetadata {
//         title
//         subtitle
//       }
//     }
//   }
// `

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPost(id: { eq: $id }) {
      title
      content
      featured_media {
        alt_text
        localFile {
          childImageSharp {
            resolutions(width: 300, height: 300) {
              src
              width
              height
            }
          }
        }
      }
      ...PostIcons
    }
    site {
      siteMetadata {
        title
        subtitle
      }
    }
  }
`;
